<template>
  <div class="imageDoc">
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Square Image</h4>
      <grid-card :min="100" :column="'auto-fill'" :gap="10">
        <template slot="item">
            <img src="/img/collection/cafe&restaurant.jpg" alt="">
            <img src="/img/collection/airport_lounge.jpg" alt="">
            <img src="/img/collection/gym.jpg" alt="">
            <img src="/img/collection/office_building.jpg" alt="">
        </template>
      </grid-card>
    </div>
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Rounded Image</h4>
      <grid-card :min="100" :column="'auto-fill'" :gap="10">
        <template slot="item">
            <img class="img-rounded" src="/img/collection/cafe&restaurant.jpg" alt="">
            <img class="img-rounded" src="/img/collection/airport_lounge.jpg" alt="">
            <img class="img-rounded" src="/img/collection/gym.jpg" alt="">
            <img class="img-rounded" src="/img/collection/office_building.jpg" alt="">
        </template>
      </grid-card>
    </div>
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Circle Image</h4>
      <grid-card :min="100" :column="'auto-fill'" :gap="10">
        <template slot="item">
            <img class="img-circle" src="/img/collection/cafe&restaurant.jpg" alt="">
            <img class="img-circle" src="/img/collection/airport_lounge.jpg" alt="">
            <img class="img-circle" src="/img/collection/gym.jpg" alt="">
            <img class="img-circle" src="/img/collection/office_building.jpg" alt="">
        </template>
      </grid-card>
    </div>
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Category Jumbotron</h4>
      <category-jumbotron 
      :title="`Digital Screen`" 
      :image="`/img/category/digitalscreen.jpg`" 
      :image-mobile="'/img/category/digitalscreen_mobile.jpg'"
      :smallTitle="'ADX ASIA'"
      :color="`#ff2d55`" 
      :description="`Nunc mattis sollicitudin tortor vel porttitor. Vivamus pretium nibh ut ante auctor, tempor condimentum magna dictum. Phasellus sed auctor velit, eget laoreet nibh. Proin non luctus sem. Nunc nisl felis, vulputate sit amet pharetra eu, tristique et arcu. Phasellus sit amet enim erat. Sed tincidunt ultricies magna, pharetra maximus justo malesuada in.`"/>
    </div>
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Home Slider</h4>
     <home-slider :data="homeSlider" />
    </div>
    <div class="imageDoc__wrapper">
      <h4 class="small-title">Detail Slider</h4>
     <detail-slider :data="detailSlider" />
    </div>
    <div class="imageDoc__wrapper card-slider">
      <h4 class="small-title">Card Slider</h4>
      <card-slider :slide="3" :slideMobile="2" :data="collections" />
    </div>
  </div>
</template>

<script>
import GridCard from '@/components/Grid/Card'
import CategoryJumbotron from '@/components/Jumbotron/Category'
import HomeSlider from '@/components/Slider/HomeSlider';
import DetailSlider from '@/components/Slider/DetailSlider';
import CardSlider from '@/components/Slider/CardSlider';

export default {
  name: 'adx-image-doc',
  components: {
    'grid-card': GridCard,
    'category-jumbotron': CategoryJumbotron,
    'home-slider': HomeSlider,
    'detail-slider': DetailSlider,
    'card-slider': CardSlider
  },
  data(){
    return {
      detailSlider: [
        {
          url: 'http://placehold.it/720x404'
        },
        {
          url: 'http://placehold.it/720x404'
        },
        {
          url: 'http://placehold.it/720x404'
        },
        {
          url: 'http://placehold.it/720x404'
        },
        {
          url: 'http://placehold.it/720x404'
        }
      ],
      homeSlider: [
        {
          url: 'https://picsum.photos/1920/1080?image=10'
        },
        {
          url: 'https://picsum.photos/1920/1080?image=10'
        },
        {
          url: 'https://picsum.photos/1920/1080?image=10'
        },
        {
          url: 'https://picsum.photos/1920/1080?image=10'
        },
        {
          url: 'https://picsum.photos/1920/1080?image=10'
        }
      ],
      collections: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
          price: '15',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
          price: '15',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
          price: '15',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`
        }
      ]
    }
  },
  methods: {

  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>